// services/mapPaddingService.ts
class MapPaddingService {
  private mapInstance?: maplibregl.Map;
  private panelStates = new Map<string, { open: boolean, width: number }>();
  
  constructor() {
    // Define default panel configurations
    this.panelStates.set('chat', { open: false, width: 350 });
    this.panelStates.set('itinerary', { open: false, width: 380 });
    this.panelStates.set('mapControls', { open: false, width: 120 });
  }
  
  setMap(map: maplibregl.Map) {
    this.mapInstance = map;
  }
  
  updatePanel(panelId: string, isOpen: boolean) {
    const panel = this.panelStates.get(panelId);
    if (panel) {
      panel.open = isOpen;
      //console.log(`[MapPadding] Panel ${panelId} is now ${isOpen ? 'open' : 'closed'}`);
      //console.log('[MapPadding] Current padding:', this.getPadding());
      this.applyPadding();
    }
  }
  
  getPadding() {
    const padding = {
      left: 0,
      right: 0,
      top: 60, // navbar
      bottom: 0
    };
    
    // Calculate based on open panels
    this.panelStates.forEach((state, panelId) => {
      if (state.open) {
        switch (panelId) {
          case 'chat':
            padding.left = Math.max(padding.left, state.width);
            break;
          case 'itinerary':
            padding.right = Math.max(padding.right, state.width);
            break;
          case 'mapControls':
            padding.left = Math.max(padding.left, state.width);
            break;
        }
      }
    });
    
    return {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
  }
  
  getBoundsPadding(extra: number = 80) {
    const base = this.getPadding();
    return {
      left: base.left + extra,
      right: base.right + extra,
      top: base.top + extra,
      bottom: base.bottom + extra
    };
  }
  
  private applyPadding() {
    if (!this.mapInstance) return;
    
    // Check if map is currently animating
    if (this.mapInstance.isMoving()) {
      //console.log('[MapPadding] Map is moving, waiting for animation to complete...');
      
      // Wait for current animation to complete
      this.mapInstance.once('moveend', () => {
        //console.log('[MapPadding] Map animation complete, applying padding');
        this.mapInstance!.easeTo({
          padding: this.getPadding(),
          duration: 300
        });
      });
    } else {
      // Apply immediately if not animating
      this.mapInstance.easeTo({
        padding: this.getPadding(),
        duration: 300
      });
    }
  }

  // Apply custom padding directly
  applyCustomPadding(padding: { left: number, right: number, top: number, bottom: number }) {
    if (!this.mapInstance) return;
    
    //console.log('[MapPadding] Applying custom padding:', padding);
    this.mapInstance.easeTo({
      padding: padding,
      duration: 300
    });
  }
}

export const mapPaddingService = new MapPaddingService();